/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
/* import { ThrowStmt } from '@angular/compiler'; */
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TonnageRatingDataRequest } from '../../../model/tonnage/tonnage-rating-request.model';
import { TonnageRatingDataResponse } from '../../../model/tonnage/tonnage-rating-response.model';
import { TonnageService } from '../../../services/tonnage/tonnage.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TonnageRating } from '../../../model/tonnage/tonnage-rating.model';
import { DropdownMenuItem } from '../../../model/tonnage/dropdown-menu-item.model';
import { DivisionResponse } from '../../../model/tonnage/division-response.model';
import { SubDivisionResponse } from '../../../model/tonnage/sub-division-response.model';
import { StationResponse } from '../../../model/tonnage/station-response.model';
import { LmsEventDetails } from '../../../model/lms-event-details.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ExportExcelService } from '../../../services/export-excel.service';
import { LmsLoaderService } from '../../../services/lms-loader.service';
import { AllDivisionsExportExcelService } from '../../../services/all-divisions-export-excel.service';
import { AllDivisionsExportPDFService } from '../../../services/all-divisions-export-pdf.service';
import { UserService } from '../../../services/user.service';


/**
 * This Tonnage Ratings Component is created for tonnage ratings related screen.
 * @export
 * @class LmsTonnageRatingsComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-tonnage-ratings',
  templateUrl: './lms-tonnage-ratings.component.html',
  styleUrls: ['./lms-tonnage-ratings.component.scss']
})
export class LmsTonnageRatingsComponent implements OnInit {
  self = this;
    trainForm = this.fb.group({
      stationId: [''],
      division: ['', Validators.required],
      subdivision: ['']
    });

    tonnageRatingHandlerData: TonnageRating[];
    allDivisionstonnageRatingHandlerData: TonnageRating[];
    notes:string[] =[];
    divisions: DropdownMenuItem[] | undefined;
    subdivisions: DropdownMenuItem[] | undefined;
    stationids: DropdownMenuItem[] | undefined;

    searchedTrain: string = null;
    showDataTable: boolean = false;

    lmtoHeadingsUI =  ["From", "To", "Miles", "3GS21B|B20-8|B40-8|GP38-2|GP40-2","SD50-2|SD50-3|SD40-2","SD50",
        "SD70M|SD60|CW44-9|CW40-9|CW40-8|C40-8","ES40DC|ES44DC|ES44C4|ET44C4",
        "SD70AE|SD70AC|SD70MA","CW44AC|CW46AC|CW44-6|CW60AC|ET44AC|SD80AC|SD90AC","CW44AH|CW46AH|CW60AH|ES44AH|ET44AH","Helpers"];
    // these are column/headers will be displayed in UI table and generated excel file
    //add \n if header need line break
    lmtoHeadings =  ["From", "To", "Miles", "3GS21B\nB20-8\nB40-8\nGP38-2\nGP40-2","SD50-2\nSD50-3\nSD40-2","SD50",
        "SD70M\nSD60\nCW44-9\nCW40-9\nCW40-8\nC40-8","ES40DC\nES44DC\nES44C4\nET44C4",
        "SD70AE\nSD70AC\nSD70MA","CW44AC\nCW46AC\nCW44-6\nCW60AC\nET44AC\nSD80AC\nSD90AC","CW44AH\nCW46AH\nCW60AH\nES44AH\nET44AH","Helpers"];
    lmtoHeaderWidths = [{ width: 17 }, { width: 17 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 10 }];

    lmtoPDFCols = [
                    { field: 'departure', header: 'From' },
                    { field: 'arrive', header: 'To' },
                    { field: 'miles', header: 'Miles' },
                    { field: 'tonCat2', header: '3GS21B\nB20-8\nB40-8\nGP38-2\nGP40-2' },
                    { field: 'tonCat3', header: 'SD50-2\nSD50-3\nSD40-2' },
                    { field: 'tonCat4', header: 'SD50' },
                    { field: 'tonCat5', header: 'SD70M\nSD60\nCW44-9\nCW40-9\nCW40-8\nC40-8' },
                    { field: 'tonCat6', header: 'ES40DC\nES44DC\nES44C4\nET44C4' },
                    { field: 'tonCat7', header: 'SD70AE\nSD70AC\nSD70MA' },
                    { field: 'tonCat8', header: 'CW44AC\nCW46AC\nCW44-6\nCW60AC\nET44AC\nSD80AC\nSD90AC' },
                    { field: 'tonCat9', header: 'CW44AH\nCW46AH\nCW60AH\nES44AH\nET44AH' },
                    { field: 'helpers', header: 'Helpers' }

                  ];

      allDivisionsLmtoHeadings =  ["From", "From Divison", "From SubDivison",  "To", "To Divison", "To SubDivison", "Miles", "3GS21B\nB20-8\nB40-8\nGP38-2\nGP40-2","SD50-2\nSD50-3\nSD40-2","SD50",
      "SD70M\nSD60\nCW44-9\nCW40-9\nCW40-8\nC40-8","ES40DC\nES44DC\nES44C4\nET44C4",
      "SD70AE\nSD70AC\nSD70MA","CW44AC\nCW46AC\nCW44-6\nCW60AC\nET44AC\nSD80AC\nSD90AC","CW44AH\nCW46AH\nCW60AH\nES44AH\nET44AH","Helpers"];
      allDivisionsLmtoHeaderWidths = [{ width: 17 }, { width: 17 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 10 }];

      allDivisionsLmtoPDFCols = [
                  { field: 'departure', header: 'From' },
                  { field: 'arrive', header: 'To' },
                  { field: 'miles', header: 'Miles' },
                  { field: 'tonCat2', header: 'GP40-2' },
                  { field: 'tonCat3', header: 'SD40-2' },
                  { field: 'tonCat4', header: 'SD50' },
                  { field: 'tonCat5', header: 'C40-8' },
                  { field: 'tonCat6', header: 'ES44DC' },
                  { field: 'tonCat7', header: 'SD70MA' },
                  { field: 'tonCat8', header: 'CW44AC' },
                  { field: 'tonCat9', header: 'CW44AH' },
                  { field: 'helpers', header: 'Helpers' }

                ];
  isHasAllDivisionsDownloadAccess: boolean;

    constructor(private fb: UntypedFormBuilder,
                private tonageService: TonnageService,
                private exportExcelService: ExportExcelService,
                private allDivisionsExportExcelService: AllDivisionsExportExcelService,
                private allDivisionsExportPDFService: AllDivisionsExportPDFService,
                private _ActivatedRoute: ActivatedRoute,
                private _router: Router,
                private lmsLoaderService: LmsLoaderService,
                private userService:UserService) {

     };


    ngOnInit() {

      this.initSubscriptions();
      this.subdivisions =[];
      this.stationids = [];
      this.loadDivisionData();
      this.isHasAllDivisionsDownloadAccess = this.userService.isUserManagerOrDirector;

    }
    initSubscriptions() {
      this.trainForm.get('division').valueChanges
      .pipe(distinctUntilChanged()).subscribe(val => {
        if (val != null) {
          const divisionCode = typeof val === 'object' ? val.code : val;
          this.loadSubDivisionData(divisionCode);
        } else {
          this.subdivisions = [];
        }
        this.stationids = [];
      });

      this.trainForm.get('subdivision').valueChanges
      .pipe(distinctUntilChanged()).subscribe(val => {
        if (val != null) {
          this.loadStationData(this.trainForm.value.division, val.code);
        } else {
          this.stationids = [];
        }
      });
    }


    searchTonnage() {
      if(this.trainForm.value.division != null){
        console.log(this.trainForm.value)
        let subdivisionValue = '';
        let stationIdValue = '';
        if(this.trainForm.value.subdivision) {
          subdivisionValue = this.trainForm.value.subdivision.code;
        }
        if(this.trainForm.value.stationId) {
          stationIdValue = this.trainForm.value.stationId.code;
        }
        this.searchLMTOTonnage(this.trainForm.value.division.code,
                              subdivisionValue,
                              stationIdValue);

      }

    }

    searchLMTOTonnage(division: string, subdivision: string, station: string){
      this.lmsLoaderService.showLoader();
      this.tonageService.fetchTonnageLMTO(division,
                                          subdivision,
                                          station).subscribe({
        next: (fetchedTonnage: TonnageRatingDataResponse)=>{
          this.showDataTable = true;
          this.tonnageRatingHandlerData = fetchedTonnage.tonnageRatingHandlerData;
          this.notes = fetchedTonnage.notes;
          this.lmsLoaderService.hideLoader();
        },
        error: ()=>{
          this.lmsLoaderService.hideLoader();
        }
      });
    }

    loadDivisionData(){
        this.tonageService.fetchDivisions().subscribe({
          next: (divisionResponse: DivisionResponse)=>{
            this.divisions = divisionResponse.divisionList;
            for (let i = 0; i < this.divisions.length; i++) {
              this.divisions[i].name = this.divisions[i].code + " - " +this.divisions[i].name;
            }
          },
          error: ()=>{

          }
        });
      }

    loadSubDivisionData(division: string){
      this.tonageService.fetchSubDivisions(division).subscribe({
        next: (subDivisionResponse: SubDivisionResponse)=>{
          this.subdivisions = subDivisionResponse.subDivisionList;
          for (let i = 0; i < this.subdivisions.length; i++) {
            this.subdivisions[i].name = this.subdivisions[i].code + " - " +this.subdivisions[i].name;
          }
        },
        error: ()=>{

        }
      });
    }

    loadStationData(division: string, subDivision: string){
      this.tonageService.fetchStations(division, subDivision).subscribe({
        next: (stationResponse: StationResponse)=>{
          this.stationids = stationResponse.stationList;
          for (let i = 0; i < this.stationids.length; i++) {
            this.stationids[i].name = this.stationids[i].code + " - " +this.stationids[i].name;
          }
        },
        error: ()=>{

        }
      });
    }



    // Util methods
    cancelTonnageForm(){
      this.trainForm.reset();
      this.showDataTable = false;
    }


    exportExcel() {
    let mainHeader =[];
    let searchFields = [];
    let emptyRow = [];
    let styles = [{"place":"A1","value":{ font: { sz: 21, color:{rgb : "4682b4"}  },alignment:{horizontal:"center"} }},
                                            {"place":"A2","value":{ font: { color:{rgb : "4682b4"}  },alignment:{horizontal:"center"}}},
                                            {"place":"A4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"B4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"C4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"D4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"E4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"F4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"G4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"H4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"I4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"J4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"K4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"L4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"M4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                                            {"place":"N4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}}];
    for (let i = 0; i < this.lmtoHeadings.length; i++) {
                mainHeader.push("");
                searchFields.push("");
                emptyRow.push("");
              }

        let centerPos = Math.floor(this.lmtoHeadings.length/2);

        if(centerPos>2) {
          centerPos = centerPos -2;
        }

        const merge = [
                { s: { r: 0, c: 0 }, e: { r: 0, c: this.lmtoHeadings.length } },
                { s: { r: 1, c: 0 }, e: { r: 1, c: this.lmtoHeadings.length } },
                { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } },
                { s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
                { s: { r: 2, c: 6 }, e: { r: 2, c: 8 } }
              ];
        mainHeader[0]='SCHEDULED TONNAGE RATINGS';
        searchFields[0]= 'Report Created on: '+(new Date()).toISOString().split('T')[0] + '  For Division: '+this.trainForm.controls['division'].value.name+ (this.trainForm.controls['subdivision'].value?('  Subdivision: '+this.trainForm.controls['subdivision'].value.name):'')+(this.trainForm.controls['stationId'].value?('   StationId: '+this.trainForm.controls['stationId'].value.name):'');
        this.exportExcelService.exportJsonExcel([mainHeader, searchFields, emptyRow,this.lmtoHeadings], this.lmtoHeaderWidths, this.formatDataForLMTO(this.tonnageRatingHandlerData), 'TonnageData', merge, styles);
     }

    exportPDF() {
      if (!this.isEmpty(this.tonnageRatingHandlerData)) {
        let titleName =  'SCHEDULED TONNAGE RATINGS';
        let searchFields = [];

          searchFields.push('Division: '+this.trainForm.controls['division'].value.name);
          if(this.trainForm.controls['subdivision'].value) {
            searchFields.push('Subdivision: '+this.trainForm.controls['subdivision'].value.name);
          }
          if(this.trainForm.controls['stationId'].value) {
            searchFields.push('StationId: '+this.trainForm.controls['stationId'].value.name);
          }


        this.allDivisionsExportPDFService.exportPDF('TonnageData',searchFields, this.populateDivSubdivMapSearch(this.formatAllDivisionsDataForLMTO(this.tonnageRatingHandlerData), this.trainForm.controls['division'].value.name.split('-')[1]), this.allDivisionsLmtoPDFCols, titleName, this.notes);

      }
    }

    public isResultsAvailable() {
      return (this.tonnageRatingHandlerData?.length > 0 && this.showDataTable);
    }

     private formatDataForLMTO(data: Array<TonnageRating>){
        return data.map((tonnageRating: TonnageRating) => {
          return {
            departure: this.convertToString(tonnageRating.departStation) + '-' + this.convertToString(tonnageRating.departMilepost) ,
            arrive: this.convertToString(tonnageRating.arriveStation) + '-' + this.convertToString(tonnageRating.arriveMilepost) ,
            miles: this.convertToString(tonnageRating.miles) ,
            tonCat2: this.convertToString(tonnageRating.tonCat2) ,
            tonCat3: this.convertToString(tonnageRating.tonCat3) ,
            tonCat4: this.convertToString(tonnageRating.tonCat4),
            tonCat5: this.convertToString(tonnageRating.tonCat5),
            tonCat6: this.convertToString(tonnageRating.tonCat6),
            tonCat7: this.convertToString(tonnageRating.tonCat7),
            tonCat8: this.convertToString(tonnageRating.tonCat8),
            tonCat9: this.convertToString(tonnageRating.tonCat9),
            helpers: this.convertToString(tonnageRating.tonHelper)
          };

        });
     }

    formatAllDivisionsDataForLMTO(data: Array<TonnageRating>){
      return data.map((tonnageRating: TonnageRating) => {
        return {
          departure: this.convertToString(tonnageRating.departStation) + ' - ' + this.convertToString(tonnageRating.departMilepost) ,
          fromDivName: this.convertToString(tonnageRating.fromDivName),
          fromSubdivName: this.convertToString(tonnageRating.fromSubdivName),      
          arrive: this.convertToString(tonnageRating.arriveStation) + ' - ' + this.convertToString(tonnageRating.arriveMilepost) ,   
          toDivName: this.convertToString(tonnageRating.toDivName),
          toSubdivName: this.convertToString(tonnageRating.toSubdivName),
          miles: this.convertToString(tonnageRating.miles) ,
          tonCat2: this.convertToString(tonnageRating.tonCat2) ,
          tonCat3: this.convertToString(tonnageRating.tonCat3) ,
          tonCat4: this.convertToString(tonnageRating.tonCat4),
          tonCat5: this.convertToString(tonnageRating.tonCat5),
          tonCat6: this.convertToString(tonnageRating.tonCat6),
          tonCat7: this.convertToString(tonnageRating.tonCat7),
          tonCat8: this.convertToString(tonnageRating.tonCat8),
          tonCat9: this.convertToString(tonnageRating.tonCat9),
          helpers: this.convertToString(tonnageRating.tonHelper)
        };

      });
   }

     private isEmpty(arr: any[]): boolean {
       if (arr === undefined || arr === null) {
         return true;
       }
       return arr.length === 0;
     }

     private convertToString(value: any) {
      if (value === undefined || value === null) {
       return '';
      } else {
        return value.toString();
      }
     }

     fetchAllDivisionsLMTOTonnageData(isExcel:boolean){
      this.lmsLoaderService.showLoader();
      this.tonageService.fetchAllDivisionsTonnageLMTO().subscribe({
        next: (fetchedTonnage: TonnageRatingDataResponse)=>{

        this.allDivisionstonnageRatingHandlerData = fetchedTonnage.tonnageRatingHandlerData;
        this.notes = fetchedTonnage.notes;
        if(isExcel)
        this.generateAllDivisionsExcel();
      else
        this.generateAllDivisionsPdf();
        this.lmsLoaderService.hideLoader();
        },
        error: ()=>{
        this.lmsLoaderService.hideLoader();
        }
        });
    }

     exportAllDivisionsExcel() {

      this.fetchAllDivisionsLMTOTonnageData(true);
     }
      generateAllDivisionsExcel(){
      let mainHeader =[];
      let searchFields = [];
      let emptyRow = [];
      let styles = [{"place":"A1","value":{ font: { sz: 21, color:{rgb : "4682b4"}  },alignment:{horizontal:"center"} }},
                    {"place":"A2","value":{ font: { color:{rgb : "4682b4"}  },alignment:{horizontal:"center"}}},
                    {"place":"A4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"B4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"C4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"D4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"E4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"F4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"G4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"H4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"I4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"J4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"K4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"L4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"M4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"N4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"O4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}},
                    {"place":"P4","value":{ font: { color:{rgb : "4682b4"}  }, alignment:{ wrapText: true }}}];
      for (let i = 0; i < this.allDivisionsLmtoHeadings.length; i++) {
                  mainHeader.push("");
                  searchFields.push("");
                  emptyRow.push("");
                }

          let centerPos = Math.floor(this.allDivisionsLmtoHeadings.length/2);

          if(centerPos>2) {
            centerPos = centerPos -2;
          }

          const merge = [
                  { s: { r: 0, c: 0 }, e: { r: 0, c: this.allDivisionsLmtoHeadings.length } },
                  { s: { r: 1, c: 0 }, e: { r: 1, c: this.allDivisionsLmtoHeadings.length } },
                  { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } },
                  { s: { r: 2, c: 3 }, e: { r: 2, c: 4 } },
                  { s: { r: 2, c: 6 }, e: { r: 2, c: 8 } }
                ];
          mainHeader[0]='SCHEDULED TONNAGE RATINGS';
          searchFields[0]= 'Report Created on: '+(new Date()).toISOString().split('T')[0];

          this.exportExcelService.exportJsonExcel([mainHeader, searchFields, emptyRow,this.allDivisionsLmtoHeadings], this.lmtoHeaderWidths, this.formatAllDivisionsDataForLMTO(this.allDivisionstonnageRatingHandlerData), 'TonnageData', merge, styles);
       }

      exportAllDivisionsPDF() {
       this.fetchAllDivisionsLMTOTonnageData(false);
      }
        generateAllDivisionsPdf(){
        if (!this.isEmpty(this.allDivisionstonnageRatingHandlerData)) {
          let titleName =  'SCHEDULED TONNAGE RATINGS'; ;
          let searchFields = [];
          this.allDivisionsExportPDFService.exportPDF('TonnageData',searchFields, this.populateDivSubdivMap(this.formatAllDivisionsDataForLMTO(this.allDivisionstonnageRatingHandlerData)), this.allDivisionsLmtoPDFCols, titleName, this.notes);
         }
      }
      populateDivSubdivMap(data: any) {

        const divisionSubdivisionMap = new Map<string, Map<string, any[]>>();


        data.forEach(item => {

          let divisionMap = divisionSubdivisionMap.get(item.fromDivName);

          if (!divisionMap) {
            divisionMap = new Map<string, any[]>();
            divisionSubdivisionMap.set(item.fromDivName, divisionMap);
          }

          let dataArray = divisionMap.get(item.fromSubdivName) || [];
          dataArray.push(item);
          divisionMap.set(item.fromSubdivName, dataArray);
        });
        return divisionSubdivisionMap;
      }

      populateDivSubdivMapSearch(data: any, selectedDivison:string) {
        const divisionSubdivisionMap = new Map<string, Map<string, any[]>>();
       // const selectedDivison:string = this.trainForm.controls['division'].value.name.split('-')[1]
        data.forEach(item => {
         
          let divisionMap = divisionSubdivisionMap.get(selectedDivison);
          
    
          if (!divisionMap) {
            divisionMap = new Map<string, any[]>();
            divisionSubdivisionMap.set(selectedDivison, divisionMap);
          }

          let subdiv: string

          if(selectedDivison.trim() === item.fromDivName.trim())
          { 
            subdiv = item.fromSubdivName
          }
          else{ 
            subdiv = item.toSubdivName
          }
    
          let dataArray = divisionMap.get(subdiv) || [];
          dataArray.push(item);
          divisionMap.set(subdiv, dataArray);
        });
        return divisionSubdivisionMap;
      }


}
